import { useNavigate, useSearchParams } from 'react-router-dom'
import { ConfirmationModal } from 'featureSliced/features/ConfirmationModal'
import { useTranslations } from 'featureSliced/shared/hooks/useTranslations'
import { useMySelector } from 'featureSliced/shared/hooks/useMySelector'
import { loadAnimation } from 'featureSliced/shared/utils/loadAnimation'
import { AnimationData } from 'featureSliced/shared/utils/animations'
import { getNavLink } from 'featureSliced/shared/utils/getNavLink'
import { useOpenModal } from '../useOpenModal'

export const useOpenAdyenRetry = () => {
  // Hooks
  const t = useTranslations()
  const navigate = useNavigate()
  const openModal = useOpenModal()
  const [searchParams] = useSearchParams()
  const appTheme = useMySelector((state) => state.app.interfaceStyles.appTheme)

  const openAdyenRetry = async (onCofirmRetry: () => void) => {
    let failedOrderJSON: AnimationData | null = null
    try {
      failedOrderJSON = await loadAnimation(`${appTheme}/callWaiter.json`)
    } catch {
      failedOrderJSON = await loadAnimation('light/failedOrder.json')
    }

    openModal({
      id: `ADYEN_RETRY_CONF_MODAL`,
      title: '',
      components: [
        ({ closeThisModal }) => (
          <ConfirmationModal
            onConfirm={() => {
              onCofirmRetry()
              closeThisModal()
            }}
            onCancel={() => {
              closeThisModal()
              navigate(getNavLink(searchParams, ''))
            }}
            okText={t('buttons.tryAgain')}
            animationJSON={failedOrderJSON}
            text={t('errors.createOrderFail')}
          />
        ),
      ],
    })
  }

  return openAdyenRetry
}
